import { Area, AreaChart, CartesianGrid, XAxis } from 'recharts';
import type { CompanyUsageTimeseriesDTO } from '@shared/schemas/usage';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  type ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';

const chartConfig = {
  inputTokens: { color: 'var(--chart-2)', label: 'Entrée' },
  outputTokens: { color: 'var(--chart-5)', label: 'Sortie' },
} satisfies ChartConfig;

export function CompanyUsageTimeseriesChart({ data }: { data: CompanyUsageTimeseriesDTO }) {
  const chartData = data.buckets.map((bucket) => ({
    bucketStart: bucket.bucketStart,
    inputTokens: bucket.totals.inputTokens,
    outputTokens: bucket.totals.outputTokens,
  }));

  return (
    <Card className="rounded-[var(--radius-surface-2xl)] border-border/70">
      <CardHeader>
        <CardTitle className="text-sm font-semibold">Tokens dans le temps</CardTitle>
        <CardDescription>Entrée et sortie agrégées pour votre entreprise.</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer className="h-[300px] w-full" config={chartConfig}>
          <AreaChart data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis
              axisLine={false}
              dataKey="bucketStart"
              minTickGap={32}
              tickFormatter={(value: string) => new Date(value).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
              })}
              tickLine={false}
            />
            <ChartTooltip content={<ChartTooltipContent />} cursor={false} />
            <ChartLegend content={<ChartLegendContent />} />
            <Area dataKey="inputTokens" fill="var(--color-inputTokens)" fillOpacity={0.22} stroke="var(--color-inputTokens)" type="monotone" />
            <Area dataKey="outputTokens" fill="var(--color-outputTokens)" fillOpacity={0.22} stroke="var(--color-outputTokens)" type="monotone" />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
